{
  "_format": "hh-sol-artifact-1",
  "contractName": "TokenFTContract",
  "sourceName": "src/backend/contracts/TokenFT.sol",
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "previousAdmin",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "newAdmin",
          "type": "address"
        }
      ],
      "name": "AdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "beacon",
          "type": "address"
        }
      ],
      "name": "BeaconUpgraded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burn",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burnFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "subtractedValue",
          "type": "uint256"
        }
      ],
      "name": "decreaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_account",
          "type": "address"
        }
      ],
      "name": "earned",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getAPR",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getReward",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "addedValue",
          "type": "uint256"
        }
      ],
      "name": "increaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_mainContract",
          "type": "address"
        },
        {
          "internalType": "string",
          "name": "_name",
          "type": "string"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "lastUpdateTime",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_payAmount",
          "type": "uint256"
        },
        {
          "internalType": "uint256[]",
          "name": "_zombiesList",
          "type": "uint256[]"
        }
      ],
      "name": "mintMonsterPay",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "myBalance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rewardPerToken",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rewardPerTokenStored",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rewardRate",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "rewards",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "stake",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stakingTotalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        }
      ],
      "name": "upgradeTo",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "userRewardPerTokenPaid",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "withdraw",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}